import { newCartToOldCartStructure } from '@wix/wixstores-client-core/dist/es/src/common/cart-services/cart-services';
export var graphqlCartToCartSummary = function (cart) {
    return newCartToOldCartStructure(cart);
};
//# sourceMappingURL=graphqlCartToCartSummary.js.map